import { ShigoPermission } from '../../auth/permissions';

export const listsReadPermissions = [
  ShigoPermission.SupplyListsRead,
  ShigoPermission.SupplyAppsRead,
] as const;

export function canReadLists(can: (permission: ShigoPermission) => boolean) {
  return listsReadPermissions.some(can);
}

export function canCreateLists(can: (permission: ShigoPermission) => boolean) {
  return can(ShigoPermission.SupplyListsCreate) || can(ShigoPermission.SupplyWrite);
}

export function canEditLists(can: (permission: ShigoPermission) => boolean) {
  return can(ShigoPermission.SupplyListsEdit) || can(ShigoPermission.SupplyWrite);
}

export function canDeleteLists(can: (permission: ShigoPermission) => boolean) {
  return can(ShigoPermission.SupplyListsDelete) || can(ShigoPermission.SupplyWrite);
}

export function canImportLists(can: (permission: ShigoPermission) => boolean) {
  return can(ShigoPermission.SupplyListsImport) || can(ShigoPermission.SupplyWrite);
}

export function canExportLists(can: (permission: ShigoPermission) => boolean) {
  return can(ShigoPermission.SupplyListsExport) || can(ShigoPermission.SupplyWrite);
}
